const Remote = ({ src, width, quality }) => {
  if (width > 1920) width = 1920;
  return `${process.env.NEXT_PUBLIC_CDN}/uploads/${width}/${src}`;
};
export const Blur = (src) => {
  return `${process.env.NEXT_PUBLIC_CDN}/uploads/30/${src}`;
};
export default Remote;
